// @ts-nocheck

export type RoomGetWithProperty = typeof RoomGetWithProperty[keyof typeof RoomGetWithProperty];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithProperty = {
  true: 'true',
  false: 'false',
} as const;
